const input_es={
    "requiredErrorMessage":"Campo obligatorio",
    "validationErrorMessage":"Dato inválido"
}  
export default input_es;